import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { IllustrationUsage, UploadedFile, UploadError } from '../interfaces';
import { UploaderHeaderDirective } from '../../uploader/directives/uploader-header.directive';
import { UploaderErrorsDirective } from '../../uploader/directives/uploader-errors.directive';
import { UploaderLoadingDirective } from '../../uploader/directives/uploader-loading.directive';
import { UploaderComponent } from '../../uploader/uploader.component';

@Component({
  selector: 'app-decorated-uploader',
  templateUrl: './decorated-uploader.component.html',
  styleUrls: [ './decorated-uploader.component.sass' ]
})
export class DecoratedUploaderComponent<T extends IllustrationUsage> implements OnInit, AfterViewInit {
  @Input() illustrationUsage: T;
  @Input() uploadedFile: UploadedFile;
  @Input() aspectRatio: '4-3' | '3-4' | '16-9' | '1-1';
  @Input() enableRemove = false;
  @Input() disableUpload = false;
  @ContentChild(UploaderHeaderDirective) headerRenderer!: UploaderHeaderDirective;
  @ContentChild(UploaderErrorsDirective) errorRenderer!: UploaderErrorsDirective;
  @ContentChild(UploaderLoadingDirective) loadingRenderer!: UploaderLoadingDirective;
  @ViewChild('uploaderContainer') uploaderContainer: ElementRef;
  @ViewChild('uploader') uploader: UploaderComponent;
  @Output()
  uploaded: EventEmitter<UploadedFile> = new EventEmitter<UploadedFile>();

  @Output()
  removed: EventEmitter<UploadedFile> = new EventEmitter<UploadedFile>();

  @Output()
  errors: EventEmitter<UploadError> = new EventEmitter<UploadError>();

  selectedFile: any;

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    if (this.illustrationUsage?.nominal_aspect_ratio) {
      const padding = 100 / this.illustrationUsage.nominal_aspect_ratio + '%';
      const width = 100 * this.illustrationUsage.nominal_aspect_ratio + '%';
      this.uploaderContainer.nativeElement.style.setProperty('--aspect-ratio-percent', padding);
    }
  }

  onFileSelected(file) {
    this.selectedFile = file;
  }

  onFileRemoved(deleted: UploadedFile) {
    if (!this.enableRemove) {
      return;
    }
    this.removed.emit(deleted);
  }

  onFileUploaded(illustrationUsage: T, file: any) {
    if (this.disableUpload) {
      return;
    }
    const uploadedFile = {usage: illustrationUsage.name, media: file};
    this.uploadedFile = uploadedFile;
    this.uploaded.emit(uploadedFile);
  }
}
